import React,{useState} from "react";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
const TicketPivotTable = ({ pivotdata }) => {
  const [pivotState, setPivotState] = useState({});

  const formattedData = Object.entries(pivotdata || {}).flatMap(
    ([status, tickets]) =>
      Array.isArray(tickets)
        ? tickets.map((ticket) => ({
            "Ticket No": ticket.ticketNo || "N/A",
            "Status": status,
            "Request Title": ticket.requestTitle || "N/A",
            "Priority": ticket.priority || "N/A",
            "Assigned To": ticket.assignedTo || "Unassigned",
            "Applicant Name": ticket.applicantName || "N/A",
            "Created By": ticket.ticketCreatedBy || "N/A",
            "Created At": new Date(ticket.createdAt).toLocaleString() || "N/A",
          }))
        : []
  );
 

  return (
    
      <PivotTableUI
        data={formattedData}
        rows={["Status"]}
        cols={["Priority"]}
        aggregatorName="Count"
        rendererName="Table"
       
        {...pivotState}
        onChange={(s) => setPivotState(s)}
      />
    
  );
};

export default TicketPivotTable;